var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.containerStyle)},[_c('div',{staticClass:"ui-image---status"},[(_vm.loadStatus === 1)?_c('div',{staticClass:"ui-image-fail"}):(_vm.loadStatus === 3)?_c('div',{staticClass:"ui-image-blocked"}):(_vm.loadStatus === 2)?_c('img',{staticClass:"ui-image-img",attrs:{"data-origin-url":_vm.src,"src":_vm.imageUrl}}):_c('div',{staticClass:"ui-image-loading"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600122f5","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/image/status.vue
// module id = 674
// module chunks = 0 1 2 3